<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="freeDocumentsGrid"
        :page-data="pageData"
        :loading="loadingAnimation"
        sort-az="last_name"
        :pagination="requestType === 'admin'"
      >
        <template v-slot:buttons>
          <!--          <ButtonFileUpload
            v-if="
              $userCheckAccess({
                abilities: 'edit_free_documents',
              })
            "
            :uploadStatus="fileUploadDocumentsStatus"
            :text="
              fileUploadDocumentsStatus
                ? localStorage.translations.pages.common.buttons['fayl-y-zagruzhayutsya']
                : localStorage.translations.pages.common.buttons['zagruzit']
            "
            format="PDF"
            :multiple="true"
            fileAccept=".pdf"
            @buttonFileUpload="onButtonFileUploadDocuments"
          />-->
          <PdfDocumentCreate
            v-if="
              $userCheckAccess({
                abilities: 'edit_free_documents',
              })
            "
            create-name
            full-button
            :upload-function="uploadDocument"
          />
        </template>
        <DocumentsShowTable :items="freeDocumentsGrid" :itemsUpload="documentsUploadGo" :downloadPageData="downloadPageData" />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import TemplateView from 'components/templates/TemplateView'
import TemplatePageGrid from 'components/templates/TemplatePageGrid'
import DocumentsShowTable from 'components/documents/show/DocumentsShowTable'
import PdfDocumentCreate from "components/pdf/pdfDocument/PdfDocumentCreate";

export default {
  name: 'documentsShow',
  components: {
    PdfDocumentCreate,
    TemplateView,
    TemplatePageGrid,
    DocumentsShowTable,
  },
  data() {
    return {
      fileUploadDocumentsStatus: false,
      documentsUpload: [],
      documentsUploadGo: [],
    }
  },
  created() {
    this.downloadPageData()
    this.onFreeDocumentsGroupsShow({
      id: this.$route.params.id,
      type: this.requestType,
    })
  },
  computed: {
    ...mapGetters('freeDocuments', ['freeDocumentsGrid', 'pageData']),
    ...mapGetters('freeDocumentsGroups', ['freeDocumentsGroupsShow']),
    ...mapGetters(['loadingAnimation']),
    requestType() {
      return this.$route.meta.requestType
    },
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },

  methods: {
    ...mapMutations('freeDocumentsGroups', ['setFreeDocumentsGroupsShow']),
    ...mapActions('freeDocumentsGroups', ['onFreeDocumentsGroupsShow']),
    ...mapActions('freeDocuments', [
      'onFreeDocumentsGrid',
      'onFreeDocumentsGridUpdate',
      'onFreeDocumentsCreate',
      'onFreeDocumentsUploadFiles',
    ]),
    async downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
        id: this.$route.params.id,
        type: this.requestType,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      await this.onFreeDocumentsGrid(data)
    },
    async uploadDocument(url, name, size) {
      console.log('url')
      this.fileUploadDocumentsStatus = true
      let nameCheck = this.freeDocumentsGrid.filter((item) => item.name == name)
      let docSize = this.$formatFileSizeUnits(size)
      this.documentsUploadGo = []
      this.documentsUploadGo.push({
        name: nameCheck.length ? name + '(1)' : name,
        status: 'progress',
        extension: 'pdf',
        size: docSize,
        key: 1,
      })
      let objIndex = this.documentsUploadGo.findIndex(
        (obj) => obj.name == this.documentsUploadGo[0].name,
      )
      console.log('objIndex')
      console.log(objIndex)
      let data = {
        free_document_group_id: this.$route.params.id,
        name: name,
        file: JSON.stringify([
          {
            url: url,
            extension: 'pdf',
            size: docSize,
          },
        ]),
      }
      await this.onFreeDocumentsCreate(data)
        .then((response) => {
          console.log('this.documentsUploadGo')
          console.log(this.documentsUploadGo)
          console.log('this.documentsUploadGo[objIndex]')
          console.log(this.documentsUploadGo[objIndex])
          this.documentsUploadGo[objIndex].status = 'done'
        })
        .catch((err) => {
          this.documentsUploadGo[objIndex].status = 'error'
          this.$store.dispatch('deleteFile', {
            url: JSON.parse(data.files)[0].url,
          })
        })

      this.downloadPageData().then((response) => {
        this.fileUploadDocumentsStatus = false
        this.documentsUploadGo = []
      })
    },
    async onButtonFileUploadDocuments(data) {
      this.documentsUpload = data.files
      this.submitFileDocument()
    },
    async submitFileDocument() {
      this.fileUploadDocumentsStatus = true
      for (let i = 0; i < this.documentsUpload.length; ++i) {
        let formData = new FormData()
        formData.append('file', this.documentsUpload[i])
        let fileFullName = this.documentsUpload[i].name
        let fileName = fileFullName.substring(0, fileFullName.lastIndexOf('.'))
        let fileExtension = fileFullName.substring(
          fileFullName.lastIndexOf('.') + 1,
          fileFullName.length,
        )
        let size = this.$formatFileSizeUnits(this.documentsUpload[i].size)
        let nameCheck = this.freeDocumentsGrid.filter((item) => item.name == fileName)
        this.documentsUploadGo.push({
          name: nameCheck.length ? fileName + '(1)' : fileName,
          status: 'progress',
          extension: fileExtension,
          size: size,
          key: i,
        })
        let objIndex = this.documentsUploadGo.findIndex(
          (obj) => obj.name == this.documentsUploadGo[i].name,
        )
        // for (var pair of formData.entries()) {
        //     console.log(pair)
        // }
        await this.onFreeDocumentsUploadFiles({
          data: formData,
        })
          .then((response) => {
            let data = {
              free_document_group_id: this.$route.params.id,
              name: nameCheck.length ? fileName + '(1)' : fileName,
              file: JSON.stringify([
                {
                  url: response.data.url,
                  extension: fileExtension,
                  size: size,
                },
              ]),
            }
            return this.onFreeDocumentsCreate(data)
              .then((response) => {
                this.documentsUploadGo[objIndex].status = 'done'
              })
              .catch((err) => {
                this.documentsUploadGo[objIndex].status = 'error'
                this.$store.dispatch('deleteFile', {
                  url: JSON.parse(data.files)[0].url,
                })
              })
          })
          .catch((err) => {
            this.documentsUploadGo[objIndex].status = 'error'
          })
      }
      this.downloadPageData().then((response) => {
        this.fileUploadDocumentsStatus = false
        this.documentsUploadGo = []
      })
    },
  },
  beforeDestroy() {
    this.setFreeDocumentsGroupsShow({})
  },
}
</script>
